import WalletHeader from "./WalletHeader";

export default WalletHeader;
